import React from 'react'
import { prop } from 'ramda'

import * as API from '~/constants/api'
import MultiSelectSearchField from '~/components/Fields/MultiSelectSearchField'

const getOptionValue = value => {
  if (value) {
    const id = prop('id', value)
    const guid = prop('guid', value)
    const name = prop('name', value)

    return { id, guid, name }
  }

  return null
}

function ContainerTypeMultiSelectField (props) {
  return (
    <MultiSelectSearchField
      api={API.CONTAINER_TYPE_LIST}
      data-cy="containerTypes"
      name="containerTypes"
      label="Container types"
      getOptionValue={getOptionValue}
      {...props}
    />
  )
}

export default ContainerTypeMultiSelectField
